import { Button, Grid, Hidden, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import moment from "moment";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { BLOGS } from "../../app/api/routes";
import { SIDE_PADDING, TOP_PADDING } from "../../app/theme/muiTheme";
const usestyles = makeStyles((theme) => ({
  root: {
    paddingTop: "5%",
  },
  bloglabeltxt: {
    fontSize: 25,
  },
  blogDatetxt: {
    fontSize: 18,
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  blogdurationtxt: {
    fontSize: 18,
    fontWeight: "normal",
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  headingtxt: {
    fontSize: 30,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  categoryWrapper: {
    fontSize: 18,
    fontFamily: theme.typography.fontFamily,
    color: theme.typography.allVariants.color,
    fontWeight: "bold",
  },
  categorytext: {
    fontWeight: "normal",
    backgroundColor: theme.palette.secondary.light,
    padding: "1% 2% 1% 2%",
    borderRadius: 5,
  },
  shortdesctxt: {
    fontSize: 18,
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  publishedbytext: {
    fontSize: 18,
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  subroot: {
    [theme.breakpoints.down("md")]: {
      paddingTop: TOP_PADDING,
      paddingBottom: SIDE_PADDING,
      paddingLeft: SIDE_PADDING,
    },
  },
}));

const BlogCard = (props) => {
  const classes = usestyles();
  const navigate = useNavigate();

  return (
    <Grid container className={classes.root} justifyContent="space-between">
      <Grid item xs={12} md={2} className={classes.subroot}>
        <Typography className={classes.bloglabeltxt}>Blogs ____</Typography>
        <br />
        <Hidden mdUp>
          <div>
            <Typography className={classes.blogDatetxt}>
              {moment(_.get(props, ["data", "updatedAt"])).format(
                "MMM Do YYYY"
              )}
              <span className={classes.blogdurationtxt}>
                &nbsp; {_.get(props, ["data", "time"])}
              </span>
            </Typography>
          </div>
        </Hidden>
        <Hidden mdDown>
          <Typography className={classes.blogDatetxt}>
            {moment(_.get(props, ["data", "updatedAt"])).format("MMM Do YYYY")}
          </Typography>
          <Typography className={classes.blogdurationtxt}>
            {_.get(props, ["data", "time"])}
          </Typography>
        </Hidden>
      </Grid>
      <Grid item xs={12} md={4} className={classes.subroot}>
        <Typography className={classes.headingtxt}>
          {_.get(props, ["data", "title"])}
        </Typography>
        <br />
        {_.get(props, ["data", "category"]) && (
          <div className={classes.categoryWrapper}>
            <span className={classes.categoryLabel}>
              Category : <span className={classes.categorytext}>Lorem</span>
              &nbsp;
              <span className={classes.categorytext}>Ipsem</span>
            </span>
          </div>
        )}
        <br />
        <Typography className={classes.shortdesctxt}>
          {_.get(props, ["data", "short_description"])}
        </Typography>
        <br />
        <Typography className={classes.publishedbytext}>
          Published By - {_.get(props, ["data", "published_by"])}
        </Typography>
        <Hidden mdDown>
          <br />

          <Button
            onClick={() => {
              navigate(`${BLOGS}/${_.get(props, ["data", "id"])}`);
            }}
          >{`Explore Blogs ->`}</Button>
        </Hidden>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        style={{
          overflow: "hidden",
        }}
      >
        <img
          alt="blog"
          src={
            _.get(props, ["data", "thumbnail"]) || "/images/blogsampleimg.svg"
          }
        />
      </Grid>
      <Hidden mdUp>
        <br />

        <Button
          style={{
            margin: "5%",
          }}
          onClick={() => {
            navigate(`${BLOGS}/${_.get(props, ["data", "id"])}`);
          }}
        >{`Explore Blogs ->`}</Button>
      </Hidden>
    </Grid>
  );
};

export default BlogCard;
